import React, { Component } from "react";
import Btn from "../../../Components/Btn";


export default class EditTripPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            popupVisible: false
        };
    }


    componentWillMount() {
        document.addEventListener('keydown', e => {
        //   console.log(e.keyCode);
          if (e.keyCode === 27) {
            this.props.toggleFn(e);
          }
        });
      }
    formatDate(string) {
        var options = { year: 'numeric', month: 'short', day: '2-digit' };
        return new Date(string).toLocaleDateString([], options);
      }
      
    render() {
        const tripData = this.props.tripsData.find(b => (b.id === this.props.currentTrip)) || {};
        return (
            <div
                className={`popup edit-trip-popup ${
                    this.props.currentTrip ? "popup_visible" : ''
                    }`}
                >
                <div className="tbl">
                    <div className="tcl">
                        <div className="popup__window">
                            <button
                                type="button"
                                className="popup__close material-icons js-popup-closer"
                                onClick={event => this.props.toggleFn(event, this.props.currentTrip)}
                            >
                                close
                            </button>
                            <div className="edit-trip-container">
                                <form action="/trips" className="editTripForm">
                                    <div className="card">
                                        <label className="label confirm">Edit Trip</label>
                                        <h4>{tripData.no}</h4>
                                        <div className="trip-info-data">
                                            <h5>Trip Date.</h5>
                                            <p>{this.formatDate(tripData.date)}</p>
                                        </div>
                                        <div className="trip-info-data">
                                            <h5>Route</h5>
                                            <p>{tripData.route ? tripData.route.from : null} - {tripData.route ? tripData.route.to : null}</p>
                                        </div>
                                    </div>
                                    <div className="card">
                                        <div className="form-field">
                                            <label className="label">Departure Time</label>
                                            <select>
                                                <option>01</option>
                                                <option>02</option>
                                                <option>03</option>
                                                <option>04</option>
                                                <option>05</option>
                                                <option>06</option>
                                                <option>07</option>
                                                <option>08</option>
                                                <option>09</option>
                                                <option>10</option>
                                                <option>11</option>
                                                <option>12</option>
                                            </select>
                                            <select>
                                                <option>00</option>
                                                <option>05</option>
                                                <option>10</option>
                                                <option>15</option>
                                                <option>20</option>
                                                <option>25</option>
                                                <option>30</option>
                                                <option>35</option>
                                                <option>40</option>
                                                <option>45</option>
                                                <option>50</option>
                                                <option>55</option>
                                            </select>
                                            <select>
                                                <option>AM</option>
                                                <option>PM</option>
                                            </select>
                                        </div>
                                        <div className="form-field">
                                            <label className="label">Return Time</label>
                                            <select>
                                                <option>01</option>
                                                <option>02</option>
                                                <option>03</option>
                                                <option>04</option>
                                                <option>05</option>
                                                <option>06</option>
                                                <option>07</option>
                                                <option>08</option>
                                                <option>09</option>
                                                <option>10</option>
                                                <option>11</option>
                                                <option>12</option>
                                            </select>
                                            <select>
                                                <option>00</option>
                                                <option>05</option>
                                                <option>10</option>
                                                <option>15</option>
                                                <option>20</option>
                                                <option>25</option>
                                                <option>30</option>
                                                <option>35</option>
                                                <option>40</option>
                                                <option>45</option>
                                                <option>50</option>
                                                <option>55</option>
                                            </select>
                                            <select>
                                                <option>AM</option>
                                                <option>PM</option>
                                            </select>
                                        </div>
                                        <div className="form-field">
                                            <label className="label">Bus Class</label>
                                            <select>
                                                <option>Regular</option>
                                                <option>class 02</option>
                                                <option>class 03</option>
                                                <option>class 04</option>
                                                <option>class 05</option>
                                                <option>class 06</option>
                                                <option>class 07</option>
                                                <option>class 08</option>
                                                <option>class 09</option>
                                                <option>class 10</option>
                                                <option>class 11</option>
                                                <option>class 12</option>
                                            </select>
                                        </div>
                                        <div className="form-field">
                                            <label className="label">
                                                Price in EGP
                                                <span className="hint tooltip">
                                                <div className="tooltip-box">
                                                    <p>Maecenas sed diam eget risus varius blandit sit amet non magna.</p>
                                                </div>
                                                </span>
                                            </label>
                                            <input type="text" value="60"/>
                                        </div>
                                    </div>
                                    <div className="card">
                                        <div className="form-field">
                                            <Btn className="btn confirm small">Save</Btn>
                                            <Btn className="btn simple">Cancel</Btn>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
